import { useState } from "react";
import { useGetCoursesQuery } from "../../../app/features/courses/courses.api";
import useError from "../../../hooks/useError";
import UserLayout from "../../../layouts/user";
import CourseList from "./_components/CourseList";
import Filter from "./_components/Filter";

const breadcrumb = [
  {
    title: "হোম",
    path: "/",
  },
  {
    title: "ড্যাশবোর্ড",
  },
];

export type IFilter = "TOTAL" | "ACTIVE" | "COMPLETED";

export default function UserCourses() {
  const [active, setActive] = useState<IFilter>("TOTAL");
  const { data, isLoading, isFetching, error } = useGetCoursesQuery({
    status: active === "TOTAL" ? undefined : active,
  });
  useError(error, "কোর্স সমূহ লোড করা যায়নি");

  return (
    <UserLayout title="কোর্স সমূহ" breadcrumb={breadcrumb}>
      <Filter active={active} setActive={setActive} courses={data} />
      <CourseList courses={data} isLoading={isLoading || isFetching} />
    </UserLayout>
  );
}
